import { useEffect, useState } from "react";
import api from "../lib/api";

export default function ExchangeConfig() {
  const [exchangeName, setExchangeName] = useState("coinbase");
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [connections, setConnections] = useState([]);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadExchanges = async () => {
    const res = await api.get("/exchanges");
    setConnections(res.data || []);
  };

  useEffect(() => {
    loadExchanges();
  }, []);

  const addExchange = async () => {
    setLoading(true);
    setStatus(null);
    try {
      await api.post("/exchanges", {
        exchange_name: exchangeName,
        api_key: apiKey,
        api_secret: apiSecret,
      });
      setApiKey("");
      setApiSecret("");
      await loadExchanges();
      setStatus({ ok: true, msg: "Exchange connected" });
    } catch (e) {
      setStatus({ ok: false, msg: e.response?.data?.detail || "Failed to add exchange" });
    } finally {
      setLoading(false);
    }
  };

  const testExchange = async (id) => {
    setStatus(null);
    try {
      const res = await api.post(`/exchanges/${id}/test`);
      setStatus({ ok: true, msg: res.data.message });
    } catch (e) {
      setStatus({ ok: false, msg: e.response?.data?.detail || "Test failed" });
    }
  };

  const deleteExchange = async (id) => {
    await api.delete(`/exchanges/${id}`);
    await loadExchanges();
  };

  return (
    <div className="p-6 max-w-xl text-gray-200">
      <h1 className="text-xl font-bold tracking-widest text-yellow-400 mb-4">
        EXCHANGE CONNECTIONS
      </h1>

      {/* Add Exchange */}
      <div className="border border-[#1f2937] bg-[#0f1720] p-4 mb-4">
        <label className="block text-xs text-gray-400 mb-1">Exchange</label>
        <select
          value={exchangeName}
          onChange={(e) => setExchangeName(e.target.value)}
          className="w-full mb-2 bg-[#020617] border border-[#1f2937] px-2 py-1"
        >
          <option value="binanceus">Binance US</option>
          <option value="coinbase">Coinbase</option>
          <option value="kraken">Kraken</option>
          <option value="bybit">Bybit</option>
        </select>

        <label className="block text-xs text-gray-400 mb-1">API Key</label>
        <input
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          className="w-full mb-2 bg-[#020617] border border-[#1f2937] px-2 py-1"
        />

        <label className="block text-xs text-gray-400 mb-1">API Secret</label>
        <input
          type="password"
          value={apiSecret}
          onChange={(e) => setApiSecret(e.target.value)}
          className="w-full mb-3 bg-[#020617] border border-[#1f2937] px-2 py-1"
        />

        <button
          onClick={addExchange}
          disabled={loading}
          className="px-4 py-2 text-xs font-bold border border-green-400 text-green-400 hover:bg-green-400 hover:text-black"
        >
          CONNECT EXCHANGE
        </button>
      </div>

      {/* Existing Exchanges */}
      {connections.map((c) => (
        <div
          key={c.connection_id}
          className="border border-[#1f2937] bg-[#020617] p-3 mb-2 flex justify-between items-center"
        >
          <div>
            <div className="text-yellow-400 font-bold text-xs">
              {c.exchange_name.toUpperCase()}
            </div>
            <div className="text-gray-500 text-[11px]">
              {c.connection_id}
            </div>
          </div>

          <div className="flex gap-2">
            <button
              onClick={() => testExchange(c.connection_id)}
              className="px-2 py-1 text-xs border border-blue-400 text-blue-400"
            >
              TEST
            </button>
            <button
              onClick={() => deleteExchange(c.connection_id)}
              className="px-2 py-1 text-xs border border-red-400 text-red-400"
            >
              DELETE
            </button>
          </div>
        </div>
      ))}

      {status && (
        <div className={`mt-3 text-xs ${status.ok ? "text-green-400" : "text-red-400"}`}>
          {status.msg}
        </div>
      )}
    </div>
  );
}

